import { Icon } from "@twilio/flex-ui-core";
import * as FlexWebChat from "@twilio/flex-webchat-ui";
import React, { Component } from "react";

class CustomHeader extends Component {
  state = { hideMinimizeIcon: true };
  timer = null;

  componentDidMount() {
    this.timer = setInterval(() => {
      const hideMinimizeIcon =
        window.location.pathname.includes("webchat-order");

      this.setState({ hideMinimizeIcon });
    }, 500);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const imageURL = process.env.REACT_APP_URL + "logo.svg";

    return (
      <div className="custom-header">
        <img alt="Flapper" className="custom-header__logo" src={imageURL} />
        <div className="custom-header__actions">
          <div
            className="custom-header__actions__button custom-header__actions__button--minimize"
            onClick={this._minimize}
          >
            {this.state.hideMinimizeIcon ? null : <Icon icon="Minus" />}
          </div>
          {/* <div className="custom-header__actions__button custom-header__actions__button--close" onClick={this._close}>
            <Icon icon="Close" />
          </div> */}
        </div>
      </div>
    );
  }

  _getImageURL = () => {
    return `${process.env.REACT_APP_URL}logo.svg`;
  };

  _minimize = () => {
    sessionStorage.setItem("flapperChatVisibility", false);
    FlexWebChat.Actions.invokeAction("MinimizeChat");
  };

  _close = () => {
    sessionStorage.setItem("flapperChatVisibility", false);
    FlexWebChat.Actions.invokeAction("ToggleChatVisibility");
  };
}

export default CustomHeader;
